<div id="speiseplanDetail" *ngIf="menu && mandant" [class.mobil]="detectedPlattform == 'mobil'">
  <ng-container *ngIf="detectedPlattform == 'web'">
    <div id="speiseplanKundeWerbebanner" *ngIf="kunde">
      <werbebanner></werbebanner>
    </div>
  </ng-container>
  <div class="speiseplan-details-titel">
    <strong>{{ menu.bezeichnung }}</strong>
    <strong *ngIf="mandant.preisPositionInSplan !== 'none'">{{ menu.preis | euroPrice }}</strong>
  </div>
  <div id="speiseplanDetailsContent" [class.mobil]="detectedPlattform == 'mobil'">
    <div class="speiseplan-details-beschreibung details-abschnitt" [innerHTML]="menu.menueText | bbCode"></div>
    <ng-container *ngIf="menuAIZ">
      <sup *ngIf="menuAIZ.length != 0" [innerHTML]="menuAIZ"></sup>
    </ng-container>
    <ng-container *ngIf="menuZusatz">
      <div id="menuZusatz" [innerHTML]="menuZusatz | img | async"></div>
    </ng-container>
    <ng-container *ngIf="zertiListe">
      <div *ngFor="let zerti of zertiListe">
        <div id="zertiListe" [innerHTML]="zerti.content | img | async"></div>
      </div>
    </ng-container>
    <div class="speiseplan-details-bestellzeiten details-abschnitt" *ngIf="menu.bestellschluss && menu.abbestellschluss">
      <div>
        <strong>Bestellschluss</strong>
        <span class="bestellzeiten"><img src="assets/icons/bestellschluss/icon_bestellschluss.webp" />{{ menu.bestellschluss | bestellzeiten }}</span>
      </div>
      <div>
        <strong>Abbestellschluss</strong>
        <span class="bestellzeiten"><img src="assets/icons/bestellschluss/icon_abbestellschluss.webp" />{{ menu.abbestellschluss | bestellzeiten }}</span>
      </div>
    </div>
    <div *ngIf="menu.naehrwerte.length > 0" class="speiseplan-details-naehrwert details-abschnitt">
      <strong>Nährwerte</strong>
      <div class="speiseplan-details-naehrwert-tabelle">
        <div *ngIf="menu.portionsGroesse" id="speiseplanDetailsPortion">
          <span>Portionsgröße:</span>
          <span>{{ menu.portionsGroesse }}g</span>
        </div>
        <p>Nährwerte pro 100g</p>
        <div *ngFor="let naehrwert of menu.naehrwerte">
          <span>{{ naehrwert.name }}</span>
          <span class="wert">{{ naehrwert.wert }}</span>
        </div>
      </div>
    </div>
    <speiseplan-glossar [mandant]="mandant" [menu]="menu"></speiseplan-glossar>
  </div>
</div>
